import { Navigate, Route, Routes } from "react-router-dom";
import { isAuthenticated } from "./lib/auth.ts";
import Login from "./pages/Login.tsx";
import Devices from "./pages/Devices.tsx";
import DeviceDetail from "./pages/DeviceDetail.tsx";
import PrivacyPage from "./pages/PrivacyPage.tsx";
import TermsPage from "./pages/TermsPage.tsx";
import Header from "./components/Header.tsx";
import { useTranslation } from "react-i18next";

function RequireAuth({ children }: { children: React.ReactNode }) {
  return isAuthenticated() ? <>{children}</> : <Navigate to="/login" replace />;
}

export default function App() {
  const { t } = useTranslation();
  return (
    <div className="nx-app">
      <Header />
      <main className="nx-main">
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* 法務ページはログイン不要・App Store / Play 審査時のリンク先 */}
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Devices />
              </RequireAuth>
            }
          />
          <Route
            path="/devices/:mac"
            element={
              <RequireAuth>
                <DeviceDetail />
              </RequireAuth>
            }
          />
          <Route path="*" element={<p style={{ padding: "2rem" }}>{t("common.not_found")}</p>} />
        </Routes>
      </main>
    </div>
  );
}
